import { styled } from 'twin.macro';

const MarkdownDelete = styled.del``;

export default MarkdownDelete;
